import {
  Card,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card';
import { Textarea } from '@/components/ui/textarea';
import { DETAIL_MODE, DETAIL_TYPE, useDetailMode } from '@/hooks/useDetailMode';

const ObjectiveScopeView = ({ document, setDocument }) => {
  const fieldsToShow = [
    {
      key: 'objective',
      label: 'Objective',
      placeholder: 'State the purpose and aim of the document...',
      type: 'textarea',
    },
    {
      key: 'scope',
      label: 'Scope',
      placeholder: 'Define the boundaries and applicability of the document...',
      type: 'textarea',
    },
  ];

  const handleFieldChange = (fieldKey, value) => {
    setDocument((prev) => ({
      ...prev,
      [fieldKey]: value,
    }));
  };

  const renderFormField = (field) => {
    const fieldValue = document[field.key] || '';

    return (
      <Card className="flex mb-4" key={field.key}>
        <CardHeader className="pb-6 grow">
          <div className="flex gap-4 items-start justify-between">
            <CardTitle className="text-base font-medium w-36">
              {field.label}
            </CardTitle>
            <CardDescription className="grow">
              <BasicField
                fieldKey={field.key}
                fieldValue={fieldValue}
                handleFieldChange={handleFieldChange}
                label={field.label}
                placeholder={field.placeholder}
                type={field.type}
              />
            </CardDescription>
          </div>
        </CardHeader>
      </Card>
    );
  };

  return (
    <div className="space-y-4">
      {fieldsToShow.map((field) => renderFormField(field))}
    </div>
  );
};

const BasicField = ({
  fieldKey,
  fieldValue,
  handleFieldChange,
  placeholder,
}) => {
  const { mode } = useDetailMode(DETAIL_TYPE.DOCUMENT);

  return (
    <>
      {mode !== DETAIL_MODE.STATIC ? (
        <Textarea
          autoResize
          className="font-mono resize-none"
          onChange={({ target }) => handleFieldChange(fieldKey, target.value)}
          placeholder={placeholder}
          value={fieldValue}
        />
      ) : (
        fieldValue
      )}
    </>
  );
};

export default ObjectiveScopeView;
